/**
 * Plano de Ação (FACR) — visão interna (avaliadores/gestão), layout mobile: o
 * cabeçalho da casca mobile + a MESMA visão do avaliador do desktop
 * (`components/plano/PlanoAvaliador`). Em tela estreita a lateral de setores vira
 * uma fileira rolável acima da lista.
 */
import { Header } from "@caint/design-system";
import { PlanoAvaliador } from "../components/plano/PlanoAvaliador.tsx";

export interface PlanoAcaoInternoProps {
  avaliacaoId: string | null;
  token: string | null;
  onBack: () => void;
}

export function PlanoAcaoInterno({ avaliacaoId, token, onBack }: PlanoAcaoInternoProps) {
  return (
    <>
      <Header title="Plano de Ação" sub="FACR · achados de maturidade 0–2" onBack={onBack} />
      <div className="m-body">
        <PlanoAvaliador avaliacaoId={avaliacaoId} token={token} />
      </div>
    </>
  );
}
